import { Alert, Box, Button, Container, Link, TextField, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useContext, useState } from "react";
import { UserContext } from "../theme/userContext";

export default function Register() {

    const navigate = useNavigate();
    const { setUser } = useContext(UserContext);

    const [error, setError] = useState("");
    const [email, setEmail] = useState("");
    const [name, setName] = useState("");
    const [surname, setSurname] = useState("");
    const [password, setPassword] = useState("");
    const [password2, setPassword2] = useState("");

    const onSubmit = async (event) => {
        event.preventDefault();

        // validate the inputs
        if (!email || !password || !name || !surname) {
            setError("Please enter your email, name, surename and password.");
            return;
        }
        if (password !== password2) {
            setError("Passwords do not match.");
            return;
        }

        // clear the errors
        setError("");

        try {
            const response = await fetch(process.env.REACT_APP_API_URI + "/api/auth/register", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    email: email.toLowerCase(),
                    name: name,
                    surname: surname,
                    password: password,
                    settings: {
                        "mode": "light",
                        "tableDensity": "standard"
                    }
                }),
            });

            const data = await response.json();
            if (!response.ok) {
                throw new Error(data?.message || "Registration failed.");
            }

            sessionStorage.setItem("authToken", data.token);
            if (data.refreshToken) {
                sessionStorage.setItem("refreshToken", data.refreshToken);
            }
            sessionStorage.setItem("user", JSON.stringify(data.user));
            setUser(data.user);
            navigate("/feed", { replace: true });
        } catch (error) {
            console.error(error.message);
            setError(error.message);
        }
    };

    return (
        <Container maxWidth="xs" sx={{ mt: 2 }}>
            <Typography variant="h5" component="h1" gutterBottom textAlign="center">
                Bei Finalyser registrieren...
            </Typography>
            {error && <Alert severity="error" sx={{ my: 2 }}>{error}</Alert>}
            <Box component="form" onSubmit={onSubmit}>
                <TextField
                    label="Email"
                    variant="outlined"
                    autoComplete="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value.toLowerCase())}
                    sx={{ mt: 1 }}
                    fullWidth
                />
                <TextField
                    label="Vorname"
                    variant="outlined"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    sx={{ mt: 1 }}
                    fullWidth
                />
                <TextField
                    label="Nachname"
                    variant="outlined"
                    value={surname}
                    onChange={(e) => setSurname(e.target.value)}
                    sx={{ mt: 1 }}
                    fullWidth
                />
                <TextField
                    label="Password"
                    variant="outlined"
                    type="password"
                    autoComplete="new-password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    sx={{ mt: 3 }}
                    fullWidth
                />
                <TextField
                    label="Password (re-enter)"
                    variant="outlined"
                    type="password"
                    autoComplete="new-password"
                    value={password2}
                    onChange={(e) => setPassword2(e.target.value)}
                    sx={{ mt: 3 }}
                    fullWidth
                />
                <Button variant="contained" type="submit" sx={{ mt: 3 }} fullWidth>Register</Button>
                <Box sx={{ mt: 2 }}>
                    Do you have allready an account? <Link href="/login">Login</Link>
                </Box>
            </Box>
        </Container>
    )
}
